export function cleanCatalogText(value) {
  return String(value || "").trim();
}

function sortedActive(items = []) {
  return (Array.isArray(items) ? items : [])
    .filter((item) => item?.active !== false)
    .slice()
    .sort((a, b) => Number(a?.order || 0) - Number(b?.order || 0) || cleanCatalogText(a?.description).localeCompare(cleanCatalogText(b?.description), "it"));
}

function appendCurrent(options, currentValue, currentLabel = "") {
  const current = cleanCatalogText(currentValue);
  if (!current || options.some((option) => String(option.value) === current)) return options;
  return [...options, { value: current, label: cleanCatalogText(currentLabel) || current }];
}

export function descriptionCatalogOptions(items = [], currentValue = "") {
  return appendCurrent(
    sortedActive(items).map((item) => ({ value: cleanCatalogText(item.description), label: cleanCatalogText(item.description) })),
    currentValue,
  );
}

export function provinceCatalogOptions(items = [], currentValue = "") {
  const options = sortedActive(items).map((item) => {
    const code = cleanCatalogText(item.code).toUpperCase();
    const description = cleanCatalogText(item.description);
    return { value: code || description, label: code ? `${description} (${code})` : description };
  });
  return appendCurrent(options, currentValue);
}

export function provinceCodeForValue(items = [], value = "") {
  const wanted = cleanCatalogText(value).toLocaleLowerCase("it");
  if (!wanted) return "";
  const match = (Array.isArray(items) ? items : []).find((item) => {
    const code = cleanCatalogText(item?.code).toLocaleLowerCase("it");
    const description = cleanCatalogText(item?.description).toLocaleLowerCase("it");
    return wanted === code || wanted === description;
  });
  return cleanCatalogText(match?.code).toUpperCase() || cleanCatalogText(value).toUpperCase();
}

export function municipalityCatalogOptions(items = [], provinceCode = "", currentCode = "") {
  const wantedProvince = cleanCatalogText(provinceCode).toUpperCase();
  const options = sortedActive(items).map((item) => {
    const code = cleanCatalogText(item.code);
    const province = cleanCatalogText(item.provinceCode).toUpperCase();
    const description = cleanCatalogText(item.description);
    return { value: code || `${description}|${province}`, label: province && province !== wantedProvince ? `${description} (${province})` : description };
  });
  return appendCurrent(options, currentCode);
}

export function findMunicipality(items = [], description = "", provinceCode = "") {
  const wantedDescription = cleanCatalogText(description).toLocaleLowerCase("it");
  const wantedProvince = cleanCatalogText(provinceCode).toUpperCase();
  if (!wantedDescription) return null;
  const candidates = (Array.isArray(items) ? items : []).filter((item) => cleanCatalogText(item?.description).toLocaleLowerCase("it") === wantedDescription);
  if (wantedProvince) return candidates.find((item) => cleanCatalogText(item?.provinceCode).toUpperCase() === wantedProvince) || null;
  return candidates[0] || null;
}


export function municipalityCodeForValue(items = [], description = "", provinceCode = "") {
  return cleanCatalogText(findMunicipality(items, description, provinceCode)?.code);
}

function normalizedMunicipalityLinkCode(value = "") {
  const cleaned = cleanCatalogText(value).replace(/\s+/g, "");
  if (!cleaned) return "";
  if (/^\d+(?:\.0+)?$/.test(cleaned)) {
    return cleaned.replace(/\.0+$/, "").replace(/^0+(?=\d)/, "");
  }
  return cleaned.toUpperCase();
}

export function normalizePostalCodeValue(value = "") {
  const cleaned = cleanCatalogText(value);
  if (/^\d{1,5}$/.test(cleaned)) return cleaned.padStart(5, "0");
  return cleaned;
}

export function postalCodeCatalogOptions(items = [], municipalityCode = "", currentValue = "") {
  const wantedMunicipality = normalizedMunicipalityLinkCode(municipalityCode);
  const current = normalizePostalCodeValue(currentValue);
  if (!wantedMunicipality) return appendCurrent([], current);
  const filtered = sortedActive(items).filter((item) => normalizedMunicipalityLinkCode(item?.municipalityCode) === wantedMunicipality);
  const seen = new Set();
  const options = filtered.reduce((result, item) => {
    const value = normalizePostalCodeValue(item?.description);
    if (!value || seen.has(value)) return result;
    seen.add(value);
    result.push({ value, label: value });
    return result;
  }, []);
  return appendCurrent(options, current);
}

export function isItaly(value = "") {
  const token = cleanCatalogText(value).toLocaleLowerCase("it");
  return ["italia", "italy", "it"].includes(token);
}
